import React from 'react';
import './FilterPresets.css';
import { PrimaryButton } from '@fluentui/react';
import TranslateTag from '../../../../Utils/Local/TranslateTag';

const FilterPresets = (props) => {
    return (
        <div className="filterpreset-content">
            <div className="filterpresets-buttons">
                <div className="filterpresets-label">
                    {TranslateTag('@GenFilA@', props.language)}:
                </div>
                {props.filterPresets.map((preset) => {
                    return (
                        <div className="filterpresets-button" key={preset.Key}>
                            <PrimaryButton
                                text={preset.Name}
                                onClick={() => props.click(preset)}
                                checked={
                                    props.selectedPreset != null &&
                                    preset.Key === props.selectedPreset.Key
                                        ? true
                                        : false
                                }
                                styles={{
                                    root: { padding: '2px' },
                                    rootChecked: { backgroundColor: 'navy' },
                                    label: { fontSize: '12px' },
                                }}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default FilterPresets;
